import { useState } from "react";
import { mediaUrl } from "../../../mediaAuth";
import type { Album } from "../../../types";

// Visual, cover-image-forward destination card for the Add page's "YOUR
// ALBUMS" grid - deliberately not AlbumCard.tsx (that one owns Albums-tab
// concerns like the options menu/drill-in navigation that don't belong on
// a destination picker) and not a text button like the old modal's. Covers
// reuse the same /assets/thumbs/ URL AlbumCard.tsx already reads from
// album.cover - no new server data needed.
export function AddAlbumCard({
  album,
  onSelect,
  busy,
  selected,
}: {
  album: Album;
  onSelect: () => void;
  busy: boolean;
  selected?: boolean;
}) {
  const [coverFailed, setCoverFailed] = useState(false);
  const count = album.mediaCount ?? (album.imageCount || 0) + (album.videoCount || 0);

  return (
    <button
      type="button"
      className={`add-album-card${selected ? " is-selected" : ""}`}
      onClick={onSelect}
      disabled={busy}
      aria-pressed={!!selected}
      aria-label={`Add to ${album.name}, ${count} ${count === 1 ? "memory" : "memories"}`}
    >
      <span className="add-album-card-cover">
        {album.cover && !coverFailed ? (
          <img src={mediaUrl(`/assets/thumbs/${album.cover}`)} alt="" onError={() => setCoverFailed(true)} />
        ) : (
          <span className="add-album-card-cover-empty" aria-hidden="true">
            <i className="bi bi-heart-fill" />
          </span>
        )}
        <span className="add-album-card-scrim" aria-hidden="true" />
        {selected && (
          <span className="add-album-card-check" aria-hidden="true">
            <i className="bi bi-check-lg" />
          </span>
        )}
        <span className="add-album-card-info">
          <span className="add-album-card-name">{album.name}</span>
          <span className="add-album-card-count">{count ? `${count} ${count === 1 ? "memory" : "memories"}` : "Empty album"}</span>
        </span>
      </span>
    </button>
  );
}
